import { Box } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { AuthoringReviewSection } from "authoring/components/authoring-review-section"
import { AuthoringRichTextReadOnly } from "authoring/components/authoring-rich-text-readonly"
import { useAmendCollapse } from "authoring/routes/project/amends/components/use-amend-collapse"
import { createDraftId } from "authoring/routes/project/lib/project-utils"

const NO_AMENDS_LABEL = "No change in this version"

// One read-only section, covering both real author notes and the synthesized "no change"
// placeholders buildScheduleCommentaryAuthorNotes() already fills in for untouched sections -
// both shapes carry the same { amendsKey, label, content, hasAmends } fields.
export function ScheduleCommentaryAuthorNoteSection({ projectId, scheduleId, note }) {
    const { isCollapsed, onToggleCollapsed } = useAmendCollapse(
        createDraftId(projectId, scheduleId),
        "scheduleCommentary"
    )
    const opacity = note.hasAmends ? 1 : 0.6

    return (
        <Bound hasAmends={note.hasAmends} isCollapsed={isCollapsed} onToggleCollapsed={onToggleCollapsed}>
            <Box sx={{ opacity }} data-cy="schedule-commentary-author-note-section">
                <AuthoringReviewSection
                    title={note.label}
                    readOnly={<AuthoringRichTextReadOnly content={note.content} emptyLabel={NO_AMENDS_LABEL} />}
                    dataCy="authoring-review-section"
                />
            </Box>
        </Bound>
    )
}
